import { FC } from 'react';
// component
import DuplicateIngredientComponent from 'components/main/Ingredients/Duplicate';

const DuplicateIngredient: FC = () => <DuplicateIngredientComponent />;

export default DuplicateIngredient;
